// Company identity keyed by the order's 3-char ISO country code.

const GBR = {
  aitHomeDelivery: 'AIT Home Delivery UK Ltd',
  aitHomeDeliveryAddress: 'Lodge Farm Industrial Estate<br />Northampton<br />NN5 7US',
  contactLink: 'http://www.aithomedelivery.com/contact/',
  metaTitle: 'AIT Home Delivery UK Ltd Tracker',
  urlLink: 'http://www.aithomedelivery.com/',
  urlText: 'www.aithomedelivery.com',
};

const DEU = {
  aitHomeDelivery: 'AIT Home Delivery GmbH',
  aitHomeDeliveryAddress: 'Europastr. 3 -5<br />31275 Lehrte',
  contactLink: 'https://www.aithomedelivery.com/de/kontaktieren-sie-unser-team/',
  metaTitle: 'AIT Home Delivery GmbH',
  urlLink: 'http://www.aithomedelivery.com',
  urlText: 'www.aithomedelivery.com',
};

// TODO PL-7620: awaiting AT values from AIT.
const AUT = { ...DEU };

export default {
  GBR,
  DEU,
  AUT,
};
